import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::deleteMethod
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/delete/{item}/item-wiki-item/{item_wiki_item}'
*/
export const deleteMethod = (args: { item: string | { id: string }, item_wiki_item: string | number | { id: string | number } } | [item: string | { id: string }, item_wiki_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/delete/{item}/item-wiki-item/{item_wiki_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::deleteMethod
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/delete/{item}/item-wiki-item/{item_wiki_item}'
*/
deleteMethod.url = (args: { item: string | { id: string }, item_wiki_item: string | number | { id: string | number } } | [item: string | { id: string }, item_wiki_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            item_wiki_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        item_wiki_item: typeof args.item_wiki_item === 'object'
        ? args.item_wiki_item.id
        : args.item_wiki_item,
    }

    return deleteMethod.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{item_wiki_item}', parsedArgs.item_wiki_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::deleteMethod
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/delete/{item}/item-wiki-item/{item_wiki_item}'
*/
deleteMethod.delete = (args: { item: string | { id: string }, item_wiki_item: string | number | { id: string | number } } | [item: string | { id: string }, item_wiki_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::undo
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/undo-delete/{item}/item-wiki-item/{Item_wiki_item_id}'
*/
export const undo = (args: { item: string | { id: string }, Item_wiki_item_id: string | number } | [item: string | { id: string }, Item_wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/undo-delete/{item}/item-wiki-item/{Item_wiki_item_id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::undo
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/undo-delete/{item}/item-wiki-item/{Item_wiki_item_id}'
*/
undo.url = (args: { item: string | { id: string }, Item_wiki_item_id: string | number } | [item: string | { id: string }, Item_wiki_item_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            Item_wiki_item_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        Item_wiki_item_id: args.Item_wiki_item_id,
    }

    return undo.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{Item_wiki_item_id}', parsedArgs.Item_wiki_item_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::undo
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/undo-delete/{item}/item-wiki-item/{Item_wiki_item_id}'
*/
undo.get = (args: { item: string | { id: string }, Item_wiki_item_id: string | number } | [item: string | { id: string }, Item_wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\DeleteItemWikiItemController::undo
* @see app/Http/Controllers/Item/DeleteItemWikiItemController.php
* @route '/api/undo-delete/{item}/item-wiki-item/{Item_wiki_item_id}'
*/
undo.head = (args: { item: string | { id: string }, Item_wiki_item_id: string | number } | [item: string | { id: string }, Item_wiki_item_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteItemWikiItemController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteItemWikiItemController